<template>
  <div>
    <h4>Существительное Substantiv</h4>

    <h5 class="indigo-text text-darken-1">Род</h5>
    
    <p>
      der - мужской род (maskulinum)
      <br />die - женский род (femininum)
      <br />das - средний род (neutrum)
    </p>
    <p>
      Род существительных в русском и немецком языке часто не совпадает.
      Поэтому род нужно учить и запоминать специально.
    </p>
    <p>
      Все существительные на: -heit, -keit, -ung, -schaft, -tät, -tion, -ei, -ur, -in, -frau относятся к женскому роду.
      <br />Все существительные на: -chen, -lein, -ment, -um, -tum относятся к среднему роду.
      <br />Все существительные, образованные от глаголов (das Arbeiten, das Ruhen) относятся к среднему роду.
      <br />Все существительные, образованные от прилагательных (das Gute, das Böse) относятся к среднему роду.
    </p>

    <br />
    <h5 class="indigo-text text-darken-1">Число</h5>

    <p>
      единственное число (singular)
      <br />множественное число (plural)
    </p>

    <h6 class="fontbold">Только в единственном числе:</h6>
    <p>1. Абстрактные понятия</p>
    <blockquote>die Geduld, der Fleiß, der Mut, das Geld, die Jugend, das Alter, das Glück, die Liebe</blockquote>

    <p>2. Материалы, вещества</p>
    <blockquote>die Milch, die Butter, der Kaffee, der Tee, das Gold, der Regen, das Leder</blockquote>

    <p>3. Группы, наборы</p>
    <blockquote>das Geschirr, das Gepäck, das Obst, die Polizei, das Getreide, die Verwandtschaft</blockquote>

    <p>4. Существительные, образованные от глаголов</p>
    <blockquote>das Laufen, das Lernen</blockquote>

    <p>5. Количество, вес</p>
    <blockquote>500 g Wurst, 2 m Stoff</blockquote>

    <h6 class="fontbold">Только во множественном числе:</h6>
    <p>1. Группы людей</p>
    <blockquote>die Eltern, die Leute</blockquote>

    <p>2. Географические названия</p>
    <blockquote>die Alpen, die Anden, die USA, die Niederlande</blockquote>

    <p>3. die Einkünfte, die Ferien, die Kosten</p>

    <h6 class="fontbold">Типы образования формы множественного числа</h6>

    <h6 class="fontbold">Тип 1:</h6>
    <h6 class="fontbold">-e (часто с Umlaut)</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                das Fest
                <br />der Brief
                <br />der Frosch
              </td>
              <td>
                die Feste
                <br />die Briefe
                <br />die Frösche
              </td>
              <td>многие односложные существительные</td>
            </tr>

            <tr>
              <td>
                die Luft
                <br />die Braut
              </td>
              <td>
                die Lüfte
                <br />die Bräute
              </td>
              <td>женский род с Umlaut</td>
            </tr>

            <tr>
              <td>der Liebling</td>
              <td>die Lieblinge</td>
              <td>существительные на -ling</td>
            </tr>

            <tr>
              <td>der König</td>
              <td>die Könige</td>
              <td>существительные на -ig</td>
            </tr>

            <tr>
              <td>der Teppich</td>
              <td>die Teppiche</td>
              <td>существительные на -ich</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">! + s</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>das Geheimnis</td>
              <td>die Geheimnisse</td>
              <td>средний род на -nis</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Тип 2:</h6>

    <h6 class="fontbold">-n (без Umlaut)</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                die Feder
                <br />die Regel
              </td>
              <td>
                die Federn
                <br />die Regeln
              </td>
              <td>
                большинство существительных
                <br />женского рода на -er, -ei
              </td>
            </tr>

            <tr>
              <td>
                die Seife
                <br />der Junge
                <br />das Auge
              </td>
              <td>
                die Seifen
                <br />die Jungen
                <br />die Augen
              </td>
              <td>женский, мужской и средний род на -e</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">-en</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                die Tat
                <br />das Bett
              </td>
              <td>
                die Taten
                <br />die Betten
              </td>
              <td>при окончании на согласную</td>
            </tr>

            <tr>
              <td>
                die Bäckerei
                <br />die Freiheit
                <br />die Ewigkeit
                <br />die Herrschaft
                <br />die Übung
              </td>

              <td>
                die Bäckereien
                <br />die Freiheiten
                <br />die Ewigkeiten
                <br />die Herrschaften
                <br />die Übungen
              </td>
              <td>
                женский род на
                <br />-ei, -heit, -keit, -schaft, -ung
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">! + n</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>die Freundin</td>
              <td>die Freundinnen</td>
              <td>женский род на -in</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Тип 3:</h6>

    <h6 class="fontbold">- (без окончания)</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                der Mantel
                <br />das Mittel
                <br />das Wunder
                <br />das Leben
              </td>
              <td>
                die Mäntel
                <br />die Mittel
                <br />die Wunder
                <br />die Leben
              </td>
              <td>
                существительные на
                <br />-el, -er, -en
              </td>
            </tr>

            <tr>
              <td>
                das Häuschen
                <br />das Männlein
              </td>
              <td>
                die Häuschen
                <br />die Männlein
              </td>
              <td>
                уменьшительные на
                <br />-chen, -lein
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Тип 4:</h6>

    <h6 class="fontbold">-er (часто с Umlaut)</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                das Feld
                <br />das Bad
              </td>
              <td>
                die Felder
                <br />die Bäder
              </td>
              <td>
                односложные существительные
                <br />среднего рода
              </td>
            </tr>

            <tr>
              <td>
                der Mann
                <br />der Mund
              </td>
              <td>
                die Männer
                <br />die Münder
              </td>
              <td>
                некоторые существительные
                <br />мужского рода
              </td>
            </tr>

            <tr>
              <td>das Bistum</td>
              <td>die Bistümer</td>
              <td>
                существительные
                <br />среднего рода на -tum
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Тип 5:</h6>

    <h6 class="fontbold">-s</h6>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>единственное число</td>
              <td>множественное число</td>
              <td></td>
            </tr>

            <tr>
              <td>
                das Taxi
                <br />der Chef
              </td>
              <td>
                die Taxis
                <br />die Chefs
              </td>
              <td>
                многие иностранные
                <br />слова
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <br />

    <h5 class="indigo-text text-darken-1">Падеж</h5>

    <h6 class="fontbold">Nominativ</h6>
    <p>
      Wer? Кто. Для людей
      <br />Was? Что. Для предметов
    </p>

    <h6 class="fontbold">Akkusativ</h6>
    <p>
      Wen? Кого. Для людей
      <br />Was? Что. Для предметов
    </p>

    <h6 class="fontbold">Dativ</h6>
    <p>Wem? Кому, чему.</p>

    <h6 class="fontbold">Genitiv</h6>
    <p>Wessen? Чей.</p>
  </div>
</template>


<style scoped>
.fontbold {
  font-weight: bold;
}
td {
  padding: 2px 2px;
}
</style>


<script>
export default {
  name: "grammatik_substantiv",
  data: () => ({}),
  computed: {}
};
</script>
